import type { TagVariant } from "@replo/design-system/components/tag/Tag";

import * as React from "react";

import { Spinner } from "@replo/design-system/components/spinner/Spinner";
import { Tag } from "@replo/design-system/components/tag/Tag";

export type IntegrationStatus =
  | "not_connected"
  | "connecting"
  | "connected"
  | "error"
  | "action_needed"
  | "syncing"
  | "paused"
  | "expired";

type StatusConfig = {
  label: string;
  variant: TagVariant;
  showSpinner: boolean;
};

const STATUS_MAP: Record<IntegrationStatus, StatusConfig> = {
  not_connected: {
    label: "Not Connected",
    variant: "neutral",
    showSpinner: false,
  },
  connecting: { label: "Connecting…", variant: "info", showSpinner: true },
  connected: { label: "Connected", variant: "success", showSpinner: false },
  error: { label: "Error", variant: "danger", showSpinner: false },
  action_needed: {
    label: "Action Needed",
    variant: "danger",
    showSpinner: false,
  },
  syncing: { label: "Syncing", variant: "info", showSpinner: true },
  paused: { label: "Paused", variant: "neutral", showSpinner: false },
  expired: { label: "Action Required", variant: "info", showSpinner: false },
};

const IntegrationStatusTag: React.FC<{
  status: IntegrationStatus;
}> = ({ status }) => {
  if (status === "not_connected") {
    return null;
  }

  const { label, variant, showSpinner } = STATUS_MAP[status];

  return (
    <Tag variant={variant} size="base">
      {showSpinner && <Spinner className="size-2.5" />}
      {label}
    </Tag>
  );
};

export default IntegrationStatusTag;
